<template>
  <div></div>
</template>

<script>
export default {
  name: 'LP',
  created () {
    window.location.href = 'https://ke.keepyou.fit/static/keep.ke.pin.html'
  },
  mounted () {
    window.location.href = 'https://ke.keepyou.fit/static/keep.ke.pin.html'
  }
}
</script>


// WEBPACK FOOTER //
// src/components/LangKyf/KE/LP.vue